export const money = (minor: number, currency: string) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency, maximumFractionDigits: minor % 100 === 0 ? 0 : 2 }).format(minor / 100);

export const day = (iso: string) => new Date(iso + "T12:00:00Z").toLocaleDateString("fr-FR", { day: "numeric", month: "short", timeZone: "UTC" });
export const range = (a: string, b: string) => `${day(a)} → ${day(b)}`;

/** "il y a 3 h" / "dans 2 h" — staff scan queues by how long things have been waiting. */
export function rel(iso: string | null, now = Date.now()): string {
  if (!iso) return "";
  const m = Math.round((Date.parse(iso) - now) / 60_000);
  const a = Math.abs(m);
  const t = a < 60 ? `${a} min` : a < 2880 ? `${Math.round(a / 60)} h` : `${Math.round(a / 1440)} j`;
  return m < 0 ? `il y a ${t}` : `dans ${t}`;
}

export const digits = (p: string | null) => (p ?? "").replace(/\D/g, "");
export const wa = (phone: string | null, text: string) => (phone ? `https://wa.me/${digits(phone)}?text=${encodeURIComponent(text)}` : null);

export const STATUS: Record<string, string> = {
  requested: "À confirmer", awaiting_payment: "Paiement attendu", confirmed: "Confirmé", in_stay: "En séjour", completed: "Terminé",
  declined: "Refusé", expired: "Expiré", cancelled_by_guest: "Annulé (client)", cancelled_by_host: "Annulé (hôte)",
};
export const METHOD: Record<string, string> = { bankily: "Bankily", sadad: "Sadad", bank_transfer: "Virement", cash: "Espèces", card: "Carte" };
export const PAY_STATUS: Record<string, string> = { due: "dû", submitted: "preuve reçue", verified: "vérifié", rejected: "rejeté", void: "annulé" };
export const POLICY: Record<string, string> = { flexible: "souple", moderate: "modérée", strict: "stricte", non_refundable: "non remboursable" };
